import { render, staticRenderFns } from "./antecedent-enf-personnel.html?vue&type=template&id=6f8740e5&scoped=true&external"
import script from "./antecedent-enf-personnel.js?vue&type=script&lang=js&external"
export * from "./antecedent-enf-personnel.js?vue&type=script&lang=js&external"
import style0 from "./antecedent-enf-personnel.scss?vue&type=style&index=0&id=6f8740e5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8740e5",
  null
  
)

export default component.exports